module.exports = __webpack_public_path__ + "static/media/strategy.c41ead07.jpg";